import { render, staticRenderFns } from "./CreateAccessPoint.vue?vue&type=template&id=a51c9cee&scoped=true"
import script from "./CreateAccessPoint.vue?vue&type=script&lang=js"
export * from "./CreateAccessPoint.vue?vue&type=script&lang=js"
import style0 from "./CreateAccessPoint.vue?vue&type=style&index=0&id=a51c9cee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51c9cee",
  null
  
)

export default component.exports